<script setup lang="ts">
import { useBreakpoint } from "@/helpers/useBreakpoint";
import type { RouteLocationRaw } from "vue-router";

defineProps<{
  to?: RouteLocationRaw;
}>();

const breakpoint = useBreakpoint();
</script>

<template>
  <VBtn
    variant="flat"
    color="primary"
    prepend-icon="mdi-plus"
    :size="breakpoint.mobile ? 'small' : 'default'"
    :to="to"
    :class="{ 'ml-4': !breakpoint.mobile }"
    v-bind="$attrs"
  >
    Skapa
  </VBtn>
</template>
